module.exports = __webpack_public_path__ + "img/nophoto.067ee004.jpeg";